/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useMemo } from "react";

// react-router components
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

// @mui material components
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";

// Material Kit 2 React themes
import theme from "assets/theme";
import Presentation from "layouts/pages/presentation";

// Material Kit 2 React routes
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-wallets";
import { clusterApiUrl } from "@solana/web3.js";
import ComingSoon from "pages/LandingPages/ComingSoon";
import PrivacyPage from "pages/LandingPages/Privacy";
import TermsOfUsagePage from "pages/LandingPages/Terms";
import WebAppPage from "pages/LandingPages/WebApp";
import routes from "routes";
import FartChampionshipPage from "./pages/LandingPages/Championship";
import { CookiesBanner } from "components/cookies";
import { SettingsProvider } from "components/settings";
import { defaultSettings } from "components/settings/config-settings";

export default function App() {
  const { pathname } = useLocation();
  const network = WalletAdapterNetwork.Devnet;
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);
  const wallets = useMemo(() => [], []);
  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <SettingsProvider defaultSettings={defaultSettings}>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <CookiesBanner />
              <Routes>
                {getRoutes(routes)}
                <Route path="/" element={<Presentation />} />
                {/* <Route path="/" element={<Presentation />} /> */}
                <Route path="*" element={<Navigate to="/" />} />
                <Route path="/coming-soon" element={<ComingSoon />} />
                <Route path="/championship" element={<FartChampionshipPage />} />
                {/* <Route path="/web-app" element={<WebAppPage />} /> */}
                <Route path="/privacy-policy" element={<PrivacyPage />} />
                <Route path="/terms-and-conditions" element={<TermsOfUsagePage />} />
              </Routes>
            </ThemeProvider>
          </SettingsProvider>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}
